import thiagoUrl from '/public/images/influencers/thiago.webp'
import isabellaUrl from '/public/images/influencers/isabella.webp'
import jadeUrl from '/public/images/influencers/jade.webp'
import brunaUrl from '/public/images/influencers/bruna.webp'
import maluUrl from '/public/images/influencers/malu.webp'
import rachelUrl from '/public/images/influencers/rachel.webp'
import chayUrl from '/public/images/influencers/chay.webp'

export const INFLUENCERS = [
  {
    imageName: 'thiago.webp',
    imageUrl: thiagoUrl,
    alt: 'Thiago Martins',
    instagram: '@thiagomartins'
  },
  {
    imageName: 'isabella.webp',
    imageUrl: isabellaUrl,
    alt: 'Isabella Santoni',
    instagram: '@isabellasantoni'
  },
  {
    imageName: 'jade.webp',
    imageUrl: jadeUrl,
    alt: 'Jade Picon',
    instagram: '@jadepicon'
  },
  {
    imageName: 'bruna.webp',
    imageUrl: brunaUrl,
    alt: 'Bruna Griphao',
    instagram: '@brunagriphao'
  },
  {
    imageName: 'malu.webp',
    imageUrl: maluUrl,
    alt: 'Malu Borges',
    instagram: '@maluborgesm'
  },
  {
    imageName: 'rachel.webp',
    imageUrl: rachelUrl,
    alt: 'Rachel Apollonio',
    instagram: '@rachelapollonio'
  },
  { imageName: 'chay.webp', imageUrl: chayUrl, alt: 'Chay', instagram: '@chay' }
]
